const TeamRequestStatus = {
  ACCEPTED: 'accepted',
  DECLINED: 'declined',
};

export default TeamRequestStatus;
